import { CSSObject } from '@chakra-ui/react';

export const Item: CSSObject = {
  display: 'flex',
  mx: '0',
  borderTop: 'none',
  minH: ['10', null, 'unset'],
  justifyContent: 'space-between',
  flexDir: 'column',
  alignItems: 'start',
  mt: '1',
  mb: '2',
  p: '2',
  py: '2',
  borderRadius: 'lg',
  gap: '1',
  bg: 'gray.100',
};

export const RacerName: CSSObject = {
  color: 'gray.700',
  fontSize: 'xs',
  whiteSpace: ['unset', null, 'nowrap'],
};

export const TextTableBarrierNumber: CSSObject = {
  color: 'gray.500',
};
